import React, { FC } from 'react';
import styled from '@emotion/styled';
import { API_VERSION } from '@ldp/common-types';
import { useSDMViewportContext } from '@ldp/sdm-contexts';
// @ts-ignore: federated module
import { WrapperSection } from '@ldp-web/component-library/ui/atoms/section';
// @ts-ignore: federated module
import { ViewResolverSection } from '../../view-resolver-section';
// @ts-ignore: federated module
import { useLayoutSectionV2 } from '@ldp/view-resolver-lite';
import { PaginationComponent } from '../../pagination';

const VIEW_RESOLVER_SECTION = {
  MAIN_CONTENT_COLLECTION: 'mainContentCollection',
  HEADLINE_SECTION: 'headlineSection',
  QUICK_FILTER_SECTION: 'quickFiltersSection',
};
const PRODUCT_GRID_COMPONENT = 'productGridComponent';

const FAVOURITE_LISTING_API_VERSION = API_VERSION.v2;

/** Listing page props */
export interface IListingPageComponentProps {
  /** children of the page */
  children?: React.ReactNode;
  /** id of component */
  id?: string;
}

/** adds additional styles for headline section */
const HeadlineContainer = styled('div')`
  & > div.chakra-container {
    margin: 0;
    padding: 0 0 1rem 0;
  }
`;

/**
 * Renders Listing page structure
 */
export const FavouriteListingPage: FC<IListingPageComponentProps> = ({ id }) => {
  const viewportContext = useSDMViewportContext();
  const isDesktopView = viewportContext.viewport === 'desktop';
  const paddingInline = isDesktopView ? '22rem' : '1.33rem';
  const { MAIN_CONTENT_COLLECTION, HEADLINE_SECTION, QUICK_FILTER_SECTION } = VIEW_RESOLVER_SECTION;

  // mainContentCollection can contain multiple product grids
  // We need the last product grid information for pagination
  const mainContentCollection = useLayoutSectionV2(MAIN_CONTENT_COLLECTION);
  const lastProductGridComponent = mainContentCollection.reduceRight((accumulator: any, component: any) => {
    if (!accumulator && component.componentId === PRODUCT_GRID_COMPONENT) {
      return component;
    }
    return accumulator;
  }, null);

  const pagination = lastProductGridComponent?.data?.pagination;
  const showPagination = pagination?.totalResults > pagination?.pageSize;

  return (
    <WrapperSection id={id} style={{ maxWidth: '120rem', paddingInline: paddingInline }}>
      <HeadlineContainer key="headline-section" data-testid="favouritelp-headline-section">
        <ViewResolverSection apiVersion={FAVOURITE_LISTING_API_VERSION} layoutSection={HEADLINE_SECTION} />
      </HeadlineContainer>
      <ViewResolverSection apiVersion={FAVOURITE_LISTING_API_VERSION} layoutSection={QUICK_FILTER_SECTION} />
      <ViewResolverSection apiVersion={FAVOURITE_LISTING_API_VERSION} layoutSection={MAIN_CONTENT_COLLECTION} />
      {showPagination && (
        <PaginationComponent
          page={pagination?.pageNumber}
          pageSize={pagination?.pageSize}
          totalResults={pagination?.totalResults}
          showGapForPagination={!isDesktopView}
        />
      )}
    </WrapperSection>
  );
};

export default FavouriteListingPage;
